export default {"src":"/_next/static/media/rectangle.a8e745be.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};